import React from 'react'
import { Redirect } from 'react-router-dom'

export default function Pool() {
  return <Redirect to="/liquidity/add" />
}
